(() => {
  const revealItems = () => {
    const items = document.querySelectorAll('[data-demeor-reveal]:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    items.forEach((item) => observer.observe(item));
  };

  const setHeaderState = () => {
    const header = document.querySelector('.shopify-section-header-sticky, sticky-header, .header-wrapper');
    if (!header) return;
    let lastY = window.scrollY;
    const update = () => {
      const y = window.scrollY;
      header.classList.toggle('demeor-header-solid', y > 24);
      header.classList.toggle('demeor-header-up', y < lastY || y < 24);
      lastY = y;
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  };

  const tickCountdowns = () => {
    document.querySelectorAll('[data-demeor-countdown]').forEach((countdown) => {
      const date = new Date(countdown.dataset.demeorCountdown);
      if (Number.isNaN(date.getTime())) return;
      const render = () => {
        const delta = Math.max(0, date.getTime() - Date.now());
        const days = Math.floor(delta / 86400000);
        const hours = Math.floor((delta % 86400000) / 3600000);
        const mins = Math.floor((delta % 3600000) / 60000);
        countdown.textContent = `${days}d ${hours}h ${mins}m`;
      };
      render();
      window.setInterval(render, 60000);
    });
  };

  const setupGiftGame = () => {
    const game = document.querySelector('[data-demeor-game]');
    if (!game) return;

    const state = {
      occasion: 'birthday',
      style: 'premium hamper',
      budget: 'around PKR 3,000',
    };
    const summary = game.querySelector('[data-game-summary]');
    const link = game.querySelector('[data-game-link]');
    const stage = game.querySelector('.demeor-game-stage');

    const render = () => {
      const isCustom = state.style === 'custom gift';
      const readable = isCustom
        ? `Custom gift - ${state.budget}`
        : `${state.occasion} - ${state.style} - ${state.budget}`;
      const message = isCustom
        ? `Hi! I'd like a custom gift from Demeor ${state.budget}. It can be for any occasion or style. Can you help me curate options, availability, and delivery?`
        : `Hi! I'd like a ${state.occasion} ${state.style} from Demeor ${state.budget}. Can you confirm options, availability, and delivery?`;
      game.classList.toggle('is-custom', isCustom);
      if (summary) summary.textContent = readable;
      if (link) link.href = `https://wa.me/923084246152?text=${encodeURIComponent(message)}`;
      if (stage) {
        stage.dataset.occasion = state.occasion;
        stage.dataset.style = state.style;
      }
    };

    game.querySelectorAll('[data-game-option]').forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.dataset.gameOption;
        state[key] = button.dataset.value;
        game.querySelectorAll(`[data-game-option="${key}"]`).forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        render();
      });
    });

    game.querySelectorAll('[data-game-option]').forEach((button) => {
      if (state[button.dataset.gameOption] === button.dataset.value) button.classList.add('is-selected');
    });
    render();
  };

  document.addEventListener('DOMContentLoaded', () => {
    revealItems();
    setHeaderState();
    tickCountdowns();
    setupGiftGame();
  });
})();
